module.exports = __webpack_public_path__ + "static/img/thonburi-logo.ef615c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thonburi-logo.png
// module id = j5YH
// module chunks = 3